module.exports = __webpack_public_path__ + "img/game2.6142993b.png";